<template>
    <div class="task">
        <Loading v-if="loading"></Loading>
        <!-- 添加二级分类 -->
        <a-modal
            title="新增章"
            :visible="parentClass.visible"
            @ok="handleOk"
            :confirmLoading="parentClass.confirmLoading"
            @cancel="parentClass.visible = false"
            v-if="parentClass.visible"
            centered
        >
            <a-form :form="form">
                <a-form-item label="新增章" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
                    <a-input v-decorator="['name', { rules: [{ required: true, message: '请输入新增章名称!' }] }]" />
                </a-form-item>
                <a-form-item label="页码" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
                  <a-input v-decorator="['ye', { rules: [{ required: true, message: '请输入新增章页码!' }] }]" />
                </a-form-item>
                <a-form-item label="段数" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
                  <a-input v-decorator="['duan', { rules: [{ required: true, message: '请输入新增章段数!' }] }]" />
                </a-form-item>
            </a-form>
        </a-modal>
        <a-modal
                title="新增节"
                :visible="parentClass.visible1"
                @ok="handleOk"
                :confirmLoading="parentClass.confirmLoading1"
                @cancel="parentClass.visible1 = false"
                v-if="parentClass.visible1"
                centered
        >
            <a-form :form="form">
                <a-form-item label="新增节" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
                    <a-input v-decorator="['name', { initialValue: editForm.name, rules: [{ required: true, message: '请输入新增节名称!' }] }]" />
                </a-form-item>
                <a-form-item label="页码" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
                  <a-input v-decorator="['ye', { initialValue: editForm.ye, rules: [{ required: true, message: '请输入新增章页码!' }] }]" />
                </a-form-item>
                <a-form-item label="段数" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
                  <a-input v-decorator="['duan', { initialValue: editForm.duan, rules: [{ required: true, message: '请输入新增章段数!' }] }]" />
                </a-form-item>
            </a-form>
        </a-modal>
        <div class="clearfix">
            <div class="fL">
                <a-breadcrumb>
                    <a-breadcrumb-item><a @click="toCourseBook">{{ className }}</a></a-breadcrumb-item>
                    <a-breadcrumb-item>{{ bookName }}</a-breadcrumb-item>
                    <a-breadcrumb-item>教材章节</a-breadcrumb-item>
                </a-breadcrumb>
            </div>
            <div class="fR">
                <a-button type="dashed" @click="AddClass(null, 1)">新增章</a-button>
            </div>
        </div>

        <a-table :columns="columns" rowKey="id" :dataSource="list" style="margin-top:20px" @expand="expand" :expandedRowKeys="expandedRowKeys" :childrenColumnName="'son'" class="table">
            <template slot="option" slot-scope="text,record">
                <a-button type="primary" style="margin-right:10px" @click="AddClass1(record, 2)" v-if="record.parent_id == 0">添加小节</a-button>
                <a-button type="primary" style="margin-right:10px" @click="editClass1(record, 2)" v-if="record.parent_id > 0">编辑小节</a-button>
                <a-popconfirm
                    title="确定删除吗?"
                    @confirm="deletClass(record.id)"
                    okText="确定"
                    cancelText="取消"
                >
                    <a-button type="danger">删除</a-button>
                </a-popconfirm>
            </template>
            <template slot="index" slot-scope="text, record">
                <span class="num">{{text}}</span><span>{{record.name}}</span>
            </template>
        </a-table>
    </div>
</template>
<script>
const columns = [
    { title: '章节/名称', dataIndex: 'index', scopedSlots: { customRender: 'index' }, },
    { title: '页', dataIndex: 'ye', align: 'center' },
    { title: '段', dataIndex: 'duan', align: 'center' },
    { title: '操作', dataIndex: 'option', scopedSlots: { customRender: 'option' },  align: 'center' },
]
import Loading from '@/components/loading'
import { getBookUnit, addBookUnit, delBookUnit } from '@/libs/api'
export default {
    name:'questionUnit',
    components:{ Loading },
    data(){
        return{
            form: this.$form.createForm(this),
            columns,
            currentId:'',
            classType:1,
            parentClass:{
                visible:false,
                confirmLoading:false,
                visible1:false,
                confirmLoading1:false,
            },
            bookId:'',
            bookName:'',
            class :'',
            className :'',
            loading:false,
            total:'',
            list:[],
            flatList:[],
            pagination:{
                page:1,
                size:10
            },
            expandedRowKeys: [],
            visible: false,
            editType: '',
            editId: '',
            editForm: [],
            currentparent: null
        }
    },
    filters:{
        num(val){
            if (val<9){
                return `0${val+1}`
            }else{
                return val
            }
        }
    },
    mounted(){
        if (this.$route.query.bookId) {
            this.class = this.$route.query.class
            this.className = this.$route.query.name
            this.bookName = this.$route.query.bookName
            this.bookId = this.$route.query.bookId
        }
        this.getList()
    },
    methods:{
        toCourseBook () {
          // href="/analysis/courseBook?name=马克思主义基本原理&class=2"
        },
        expand(expanded, record){
            if(!expanded){
                let index = this.expandedRowKeys.findIndex(el=>el == record.id)
                this.expandedRowKeys.splice(index, 1)
            }else{
                this.expandedRowKeys.push(record.id)
            }
        },
        handleOk(e){
            e.preventDefault();
            this.form.validateFieldsAndScroll((err, values) => {
                if (!err) {
                    this.parentClass.confirmLoading = true
                    let request = {}
                    if(this.classType == 1){
                        request = { bookId: this.bookId, type: 1, ...values }
                    }else if(this.classType == 2){
                        request = { bookId: this.bookId, type: 2, ...values }
                        if(this.editId){
                            request.id = this.editForm.id;
                        }else{
                            request.parent_id = this.currentparent.id;
                        }

                    }
                    // this.$route.query.exam
                    addBookUnit(request).then(res=>{
                        // this.findItemById(this.list, request, res.id)
                        this.parentClass.visible = false
                        this.parentClass.confirmLoading = false
                        this.parentClass.visible1 = false
                        this.parentClass.confirmLoading1 = false
                        this.getList();
                    },error=>{
                        console.log(error)
                        this.parentClass.confirmLoading = false
                    })
                }
            });
            this.editId = ''
            this.editForm = []
        },
        findItemById(datas, {id}, data){
            datas.forEach(el => {
                if(el.id == id){
                    if(el.son && el.son.length){
                        el.son.push({index: `${el.index}-${el.son.length+1}`, level: el.level+1, ...data})
                        let index = this.expandedRowKeys.findIndex(key => key == el.id)
                        this.expandedRowKeys.splice(index, 1)
                        this.expandedRowKeys.push(el.id)
                    }else{
                        el.son = [{
                            index: `${el.index}-1`,
                            level: el.level+1,
                            ...data
                        }]
                        this.expandedRowKeys.push(el.id)
                    }
                }
                if(el.son && el.son.length){
                    this.findItemById(el.son, {id}, data)
                }
            })
        },
        dealArray(data){
            data.forEach((el, index) => {
                this.flatList.push(el)
                if(el.level == 0){
                    el.index = index+1
                }else{
                    el.index += `-${Number(index+1)}`
                }
                if(el.son && el.son.length){
                    this.expandedRowKeys.push(el.id)
                    el.son.forEach((son, sonIndex)=>{
                        if(son)
                        son.index =`${el.index}`
                    })
                    this.dealArray(el.son)
                }else{
                    delete el.son
                }
            })
        },
        getList(){
            this.loading = true
            this.list = []
            this.expandedRowKeys = []
            this.flatList = []

            getBookUnit({bookId: this.bookId}).then(res=>{
                this.loading = false
                if(res.length){
                    res.forEach(el=>{
                        el.show = false
                    })
                    this.list = res
                    this.dealArray(this.list)
                }
            },error=>{
                this.loading = false
                console.log(error)
            })
        },
        deletClass(id){
            delBookUnit({id}).then(res=>{
               this.getList()
           },error=>{
               console.log(error)
           })
        },
        findDelById(data, id, parent_id){
            data.forEach(el => {
                if(el.id == parent_id){
                    if(el.son.length ==1){
                        delete el.son
                        let index = this.expandedRowKeys.find(key => key == parent_id)
                        this.expandedRowKeys.splice(index, 1)
                    }else{
                        let index = el.son.findIndex(key => key.id == id)
                        el.son.splice(index, 1)
                        el.son.forEach((s, i) => {
                            s.index = `${el.index}-${i+1}`
                        })
                    }
                }
                if(el.son && el.son.length){
                    this.findDelById(el.son, id, parent_id)
                }
            })
        },
        AddClass(item, type){
            this.classType = type
            this.parentClass.visible = true
        },
        AddClass1(item, type){
          this.classType = type
          this.currentparent = item
          this.editId = ''
          this.editForm = []
          this.parentClass.visible1 = true
        },
        editClass1(item, type){
          this.classType = type
          this.editForm = item
          this.editId = item.id
          this.parentClass.visible1 = true
        },
    }
}
</script>
<style lang="less" scoped>
.iconGroup{
    >*{
        padding: 0 12px;
        display: inline-block;
        vertical-align: middle;
    }
    .headImg{
        width: 36px;
        height: 36px;
        border-radius: 100%;
        background: #f07e66;
        overflow: hidden;
        img{
            width: 100%;
            height: 100%;
            display: block
        }
        &.noImg{
            background: #fff
        }
    }
    .processNum{
        color: #4165e0;
        width: 75px;
        font-weight: bold
    }
}
.iconGroup  .anticon{
    font-size:24px;
    color: #4165e0;
    cursor: pointer;
}
.btn{
    width: 105px;
}
.examList{
    margin-bottom:0;
    &.active{
        background: #5180e0;
        color: #fff;
        .num{
            color: #fff
        }
    }
}
.fL .btn{
    background: none;
    color: #5180e0;
    border: 1px solid #5180e0;
    &.active{
        color: #fff;
        background: #5180e0
    }
}
.sonList{
    margin: 0 20px;
    background: #fff;
    border: 1px dashed #5180e0;
    border-top: 0;
    padding: 0 20px;
    overflow: hidden;

}
.slide-fade-enter-active,.slide-fade-leave-active{
  transition: all .5s ease;
}
.slide-fade-enter, .slide-fade-leave-active {
    height: 30%;
    opacity: 0;
}
.transformIcon{
    transition: transform .3s ease-in-out;
    &.active{
        color: #fff;
        transform: rotateZ(90deg)
    }
}
.iconGroup{
    font-size: 16px
}
.sonItem{
    font-size: 16px;
    height: 60px;
    line-height: 60px;
    padding:0 20px;
    border-bottom: 1px dashed #5180e0;
    &:last-child{
        border-bottom: 0
    }
}
.table{
    /deep/ .ant-table{
        font-size: 16px;
    }
    .num{
        margin-right: 30px;
    }
}
</style>
